/* eslint-disable */

import React from 'react'
import { createScope, map, transformProxies } from './helpers'

const scripts = [

]

let Controller

class NavComponentView extends React.Component {
  static get Controller() {
    if (Controller) return Controller

    try {
      Controller = require('../controllers/NavComponentController')
      Controller = Controller.default || Controller

      return Controller
    }
    catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = NavComponentView

        return Controller
      }

      throw e
    }
  }

  componentDidMount() {
    /* View has no WebFlow data attributes */

    scripts.concat(null).reduce((active, next) => Promise.resolve(active).then((active) => {
      const loading = active.loading.then((script) => {
        new Function(`
          with (this) {
            eval(arguments[0])
          }
        `).call(window, script)

        return next
      })

      return active.isAsync ? next : loading
    }))
  }

  render() {
    const proxies = NavComponentView.Controller !== NavComponentView ? transformProxies(this.props.children) : {
      'logo-button': [],
      'pm-button': [],
      'folio-button': [],
      'help-button': [],
      'quote-button': [],
      'shop-button': [],
    }

    return (
      <span>
        <style dangerouslySetInnerHTML={{ __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/pss-quotes.webflow.css);
        ` }} />
        <span className="af-view">
          <div data-animation="default" data-collapse="medium" data-duration={400} data-easing="ease" data-easing2="ease" role="banner" className="af-class-navbar-2 w-nav">
            <div className="af-class-nav-bar-container w-container">
              {map(proxies['logo-button'], props => <a href="#" {...{...props, className: `w-nav-brand ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment><img src="images/NEW-pss-logo.svg" loading="lazy" width={92} height="Auto" alt="pss logo" className="af-class-image-3" /></React.Fragment>}</a>)}
              <div className="w-nav-button">
                <div className="w-icon-nav-menu" />
              </div>
              <nav role="navigation" className="af-class-nav-menu-2 w-nav-menu">
                {map(proxies['pm-button'], props => <a href="#" {...{...props, className: `af-class-nav-bar-item w-inline-block ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment><img src="images/poster-maker-icon.svg" loading="lazy" width={25} height alt="poster maker page" className="af-class-nav-icon" />
                  <div className="af-class-text-block">Poster Maker</div>
                </React.Fragment>}</a>)}
                {map(proxies['folio-button'], props => <a href="#" {...{...props, className: `af-class-nav-bar-item w-inline-block ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment><img src="images/folio-icon.svg" loading="lazy" width={25} height={40} alt="folio page" className="af-class-nav-icon" />
                  <div className="af-class-text-block">Folio</div>
                </React.Fragment>}</a>)}
                {map(proxies['help-button'], props => <a href="#" {...{...props, className: `af-class-nav-bar-item w-inline-block ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment><img src="images/help.svg" loading="lazy" width={25} alt="help page" className="af-class-nav-icon" />
                  <div className="af-class-text-block">Help</div>
                </React.Fragment>}</a>)}
                {map(proxies['quote-button'], props => <a href="#" {...{...props, className: `af-class-nav-bar-item w-inline-block ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment><img src="images/quote-icon.svg" loading="lazy" width={25} alt="quote page" className="af-class-nav-icon" />
                  <div className="af-class-text-block">Quote</div>
                </React.Fragment>}</a>)}
                {map(proxies['shop-button'], props => <a href="#" {...{...props, className: `af-class-nav-bar-item w-inline-block ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment><img src="images/inks-icon.svg" loading="lazy" width={25} alt="supplies shop" className="af-class-nav-icon" />
                  <div className="af-class-text-block">Supplies Shop</div>
                </React.Fragment>}</a>)}
              </nav>
            </div>
          </div>
        </span>
      </span>
    )
  }
}

export default NavComponentView

/* eslint-enable */